import { render, staticRenderFns } from "./monitoring-appointments.vue?vue&type=template&id=b3e9bd2c&scoped=true"
import script from "./monitoring-appointments.vue?vue&type=script&lang=js"
export * from "./monitoring-appointments.vue?vue&type=script&lang=js"
import style0 from "./monitoring-appointments.vue?vue&type=style&index=0&id=b3e9bd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e9bd2c",
  null
  
)

export default component.exports